"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _heading = _interopRequireDefault(require("../heading"));
var _excluded = ["children", "className", "standardLayout"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var BottomSheetHeading = function BottomSheetHeading(_ref) {
  var children = _ref.children,
    className = _ref.className,
    standardLayout = _ref.standardLayout,
    headingProps = _objectWithoutProperties(_ref, _excluded);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_heading["default"], _extends({
    className: (0, _classnames["default"])('mb4', className, {
      // Create space for close button to be inline with heading and not overlap.
      // For standard layout, this is only needed in the smaller viewports.
      mr9: !standardLayout,
      'mr5 md-mr0': standardLayout
    }),
    size: "sm",
    tagName: "h2"
  }, headingProps), children);
};
var _default = exports["default"] = BottomSheetHeading;